import{LOGIN_STATE_COOKIE_NAME as o}from"../../services/consts.js";const e=({cookies:e,isUserLoggedIn:s})=>{let t=e?.[o];return t=t?decodeURIComponent(t):"",t===s.toString()};export{e as validateCookieLoginState};
